export const THIRD_PARTY_LOGIN = [
  {
    searchParamsKey: 'lenovoid.hidegoogle',
    i18nKey: 'google_login_button',
    svgName: 'google',
    thirdName: 'google',
  },
  // {
  //   searchParamsKey: 'lenovoid.hideapple',
  //   i18nKey: 'apple_login_button',
  //   svgName: 'apple',
  //   thirdName: 'apple',
  // },
  {
    searchParamsKey: 'lenovoid.hidemicrosoft',
    i18nKey: 'microsoft_login_button',
    svgName: 'microsoft',
    thirdName: 'msn',
  },
  {
    searchParamsKey: 'lenovoid.hidefacebook',
    i18nKey: 'facebook_login_button',
    svgName: 'facebook',
    thirdName: 'facebook',
  },
];

export const RECAPTCHA_URL_MAP = {
  US: 'https://www.google.com/recaptcha/enterprise.js',
  CN: 'https://www.recaptcha.net/recaptcha/enterprise.js',
};

export const CALLBACK_MESSAGE = 'social-login-callback';
export const SKIP_ENABLE_FIDO = 'SKIP_ENABLE_FIDO';
export const IS_PROD = import.meta.env.MODE === 'prod';
